<form [formGroup]="defForm" (ngSubmit)="onSave()">
    <div class="definition-main-container">
        <div class="definition-instructions-container">
            <r1-compass-lib-instructions headerText="Settings"
                >Provide a name and description for the dynamic content. Then confirm the folder selected is the desired
                save location for the dynamic content. Required fields are denoted with an asterisk *.
            </r1-compass-lib-instructions>
        </div>
        <div class="definition-fields-container">
            <form [formGroup]="defForm">
                <div class="form-row-container">
                    <span class="field-row-name">Content Name *</span>
                    <mat-form-field class="field-wrapper">
                        <mat-label>Content Name</mat-label>
                        <input matInput type="text" formControlName="name" />
                        @if (defForm.controls.name.hasError('required')) {
                            <mat-error>Field is required</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row-container">
                    <span class="field-row-name">Content Description</span>
                    <mat-form-field class="field-wrapper">
                        <mat-label>Content Description</mat-label>
                        <textarea id="descriptionTextArea" matInput rows="3" formControlName="description"></textarea>
                    </mat-form-field>
                </div>
                <div class="form-row-container">
                    <span class="field-row-name">Available for Play Importer</span>
                    <div class="field-wrapper checkbox-container">
                        <mat-slide-toggle
                            [checked]="linkToPlayImporter"
                            (change)="onPlayImporterLink($event.checked)" />
                    </div>
                </div>
                @if (linkToPlayImporter) {
                    <div class="form-row-container">
                        <span class="field-row-name">Play</span>
                        <mat-form-field class="field-wrapper">
                            <mat-label>Play Importer</mat-label>
                            <mat-select [formControl]="defForm.controls.playImporterId">
                                @for (play of playImporterOptions; track $index) {
                                    <mat-option [value]="play.id">{{ play.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                }
            </form>
        </div>
    </div>
    <div class="footer-container">
        <button mat-raised-button color="primary" [disabled]="disableSave()" type="submit">Save</button>
    </div>
</form>
